import EnumClass, { build } from '../EnumClass';
import data, { RtcBotTypeId, RtcBotTypeData } from './data';
import * as Translations from './translations';

export class RtcBotType extends EnumClass<RtcBotTypeId, RtcBotTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: RTC_BOT_TYPES,
  getById: getRtcBotTypeById,
  marshaller: RtcBotTypeMarshaller,
} = build<RtcBotTypeId, RtcBotTypeData, RtcBotType>('RtcBotTypeEnum', data, RtcBotType);
